import React from 'react'
import { useInView } from 'react-intersection-observer'
import Slider from '../slider'

import arrowRightIcon from '../../icons/arrow-right.svg'

const SliderPartners = ({data, isOffer = false}) => {
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})
  let options = '{ "slidesPerView": 1, "spaceBetween": 24,"breakpoints": { "768": { "slidesPerView": 3, "slidesPerGroup": 3, "spaceBetween": 32 }, "1280": { "slidesPerView": 4, "slidesPerGroup": 4, "spaceBetween": 32 }} }'

  if (isOffer) {
    options = '{ "slidesPerView": 1, "spaceBetween": 24,"breakpoints": { "768": { "slidesPerView": 3, "slidesPerGroup": 3, "spaceBetween": 32 }, "1280": { "slidesPerView": 3, "slidesPerGroup": 3, "spaceBetween": 32 }} }'
  }

  return (
    <div ref={ref} className={inView ? 'has-anim' : ''}>
      <h2 className="title slider-cards-title title-slice scroll-anim-el">{ data.title }</h2>
      
      <div className="slider-cards slider-cards--partners">
        <Slider
          name="partners" 
          hasCards="true"
          nbItems={data.items.length}
          options = {options}>

          {data.items.length > 0 && data.items.map((item, i) => {
            const partner = (item.fields) ? item.fields : item
            const logo = (item.fields) ? partner.logo.fields : partner.logo
            const logoFile = (item.fields) ? logo.file.fields.file.url : logo.file.file.url

            return (
              <a key={i} href={partner.link} target="_blank" rel={`noopener noreferrer ${partner.noFollow ? 'nofollow' : ''}`} className={`partner-card scroll-anim-el scroll-anim-el--${i + 2}`}>
                <div className="partner-card__img-wrap center">
                  <img className="partner-card__img" src={logoFile} alt={logo.altImage} />
                </div>
                
                <svg className="icon-night" width="32" height="32">
                  <use xlinkHref={arrowRightIcon.url} />
                </svg>
              </a>
            )
          })}
        </Slider>
      </div>
    </div>
  )
}

export default SliderPartners